module.exports = __webpack_public_path__ + "static/media/comment-alt-dollar.cb2b9d9e.svg";